'use client';

import Link from 'next/link';
import { FC } from 'react';
import Icon from '~/components/icon';
import ILink from '~/data/strapi/types/shared-components/link';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';

import styles from './styles.module.css';

interface Props {
  link: ILink;
}

const Profile: FC<Props> = ({ link }) => {
  const { title, href } = link;
  const { captureGoal } = useMetrika();

  if (!href || !title) return null;

  const onRegistrationClick = () => {
    captureGoal(YMGoal.REGISTRATION_CLICK);
  };

  return (
    <Link href={href} target="_blank" title={title} onClick={onRegistrationClick}>
      <Icon name="profile" className={styles.icon} />
    </Link>
  );
};

export default Profile;
